module.exports = __webpack_public_path__ + "img/marker_red.4ff7e2f6.svg";